import {
  CONTEXTS_COLUMNS,
  CONTEXTS_COLUMNS_STORAGE_KEY,
} from "components/Environment/constants/contextTable";
import {
  ENV_VARS_COLUMNS,
  ENV_VARS_COLUMNS_STORAGE_KEY,
} from "components/Environment/constants/envVariableTable";
import {
  MOUNTED_FILES_COLUMNS,
  MOUNTED_FILES_COLUMNS_STORAGE_KEY,
} from "components/Environment/constants/mountedFilesTable";
import {
  SPACELIFT_VARS_COLUMNS,
  SPACELIFT_VARS_COLUMNS_STORAGE_KEY,
} from "components/Environment/constants/spaceliftVarsTable";
import createTableStore from "ds/components/Table/store/useTableStore";

export const useEnvironmentVariablesTableStore = createTableStore({
  storageKey: ENV_VARS_COLUMNS_STORAGE_KEY,
  config: ENV_VARS_COLUMNS,
});

export const useEnvironmentSpaceliftVariablesTableStore = createTableStore({
  storageKey: SPACELIFT_VARS_COLUMNS_STORAGE_KEY,
  config: SPACELIFT_VARS_COLUMNS,
});

export const useEnvironmentMountedFilesTableStore = createTableStore({
  storageKey: MOUNTED_FILES_COLUMNS_STORAGE_KEY,
  config: MOUNTED_FILES_COLUMNS,
});

export const useEnvironmentContextsTableStore = createTableStore({
  storageKey: CONTEXTS_COLUMNS_STORAGE_KEY,
  config: CONTEXTS_COLUMNS,
});
